import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/i18n/LanguageContext";

export default function FAQ() {
  const { t, lang } = useLanguage();
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 bg-ink-soft">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="text-gold text-sm uppercase tracking-[0.3em] font-semibold mb-4">{t.faq.eyebrow}</div>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl text-white leading-[0.95] break-words">
            {t.faq.headingLine1}
            <br />
            <span className="text-gold">{t.faq.headingLine2}</span>
          </h2>
        </div>

        <Accordion
          key={lang}
          type="single"
          collapsible
          data-testid="faq-accordion"
          className="mt-14"
        >
          {t.faq.items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-ink-line"
            >
              <AccordionTrigger className="text-left text-base md:text-lg font-bold text-white hover:text-gold hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
